import type {EditorStarterItem} from '../../vendor/src/features/remotion-editor/editor/items/item-type';
import {readTimelineAnimationWindow} from '../../protocol/animation-window';

export function preserveCodeClock<T extends EditorStarterItem>(item:T,fps:number,offsetFrames=0,sourceDuration=item.durationInFrames,capturedOnly=false):T{
  if(item.type!=='code')return item;
  const old=readTimelineAnimationWindow(item.codeClock);
  if(capturedOnly&&!old)return item;
  return {...item,codeClock:{startInSeconds:(old?.startInSeconds??0)-offsetFrames/fps,endInSeconds:(old?.endInSeconds??sourceDuration/fps)-offsetFrames/fps}};
}
